module.exports = __webpack_public_path__ + "img/ace-of-spades-display.c662c820.png";